import DetailsForm from './DetailsForm';

export {
  DetailsForm,
};



// WEBPACK FOOTER //
// ./src/components/page/ConvertDetails/components/index.js